























import Vue from 'vue'
import { TextLink } from '@raksul/raksul-common-ui'
import { Carousel } from '@/top/types'
import { IMAGE_VARIANT } from '@/common/const'
import BaseImage from '@/common/components/BaseImage.vue'

export default Vue.extend({
  name:'SidebarBrands',
  components: {
    TextLink,
    BaseImage
  },
  props: {
    brandItems: {
      type: Array as () => Carousel[],
      required: true
    }
  },
  computed: {
    IMAGE_VARIANT() {
      return IMAGE_VARIANT.BRAND
    }
  }
})
